import { render, staticRenderFns } from "./PayedUpfront.vue?vue&type=template&id=3564faa5&"
import script from "./PayedUpfront.vue?vue&type=script&lang=js&"
export * from "./PayedUpfront.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports